import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { compose } from "redux";
import { connect } from "react-redux";
import { useFormikContext } from "formik";
import { Button } from "reactstrap";
import {
  editSubscriptionPackage,
  getSubscriptionAllDetails
} from "services/SubscriptionPackageServices";
import navigationAction from "redux/navigation/actions";
import ReactQuill from "react-quill";
import enhancer from "./enhancer/EditSubscriptionEnhancer";
import Loader from "components/Loader";
import "react-quill/dist/quill.snow.css";

const { success, error, fetching } = navigationAction;

function EditSubscription(props) {
  let [id, setId] = useState("");
  let [loading, setLoading] = useState(false);
  let {
    errors,
    isValid,
    handleSubmit,
    setFieldValue,
    setValues,
    values,
    getFieldProps,
    touched,
    submitCount,
    token
  } = props;
  const formik = useFormikContext();
  const handleManualBlur = field => {
    formik.setFieldTouched(field);
  };
  const getPrefilledData = async () => {
    await getSubscriptionAllDetails(token).then(response => {
      if (response.success) {
        let data = response.data[0];
        setId(data._id);
        setValues({ ...data });
      }
    });
  };
  const handleEditSubscription = async e => {
    e.preventDefault();
    setLoading(true);
    handleSubmit();
    if (isValid) {
      await editSubscriptionPackage(token, id, values).then(response => {
        if (response.success) {
          success(response.message);
          setLoading(false);
        } else {
          error(response.message);
          setLoading(false);
        }
      });
    }
    setLoading(false);
  };
  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };
  useEffect(() => {
    getPrefilledData();
  }, []);
  return (
    <div className="work-card ">
      <div className="row mb-3">
        <div className="col-sm headline ml-2">Edit Subscription</div>
      </div>
      <div className="work-body mt-4 card-box p-4">
        <div className="div-container">
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="name">
                  Package Name <span className="text-danger">*</span>{" "}
                </label>
                <input
                  type="text"
                  className="form-control react-form-input custom-input-class"
                  placeholder="Enter package name"
                  {...getFieldProps("name")}
                />
                <Error field="name" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="name">
                  Package Price <span className="text-danger">*</span>{" "}
                </label>
                <input
                  type="string"
                  className="form-control react-form-input custom-input-class"
                  placeholder="Enter package price"
                  {...getFieldProps("price")}
                />
                <Error field="price" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="name">
                  Price per user <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control react-form-input custom-input-class"
                  placeholder="Enter price per user"
                  {...getFieldProps("price_per_user")}
                />
                <Error field="price_per_user" />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="description">
                  Description <span className="text-danger">*</span>
                </label>
                <ReactQuill
                  theme="snow"
                  name="description"
                  modules={EditSubscription.modules}
                  formats={EditSubscription.formats}
                  value={values.description}
                  placeholder="Enter package description"
                  onChange={(content, delta, source, editor) => {
                    if (editor.getLength() <= 1) {
                      setFieldValue("description", "");
                    } else {
                      setFieldValue("description", content);
                    }
                  }}
                  onBlur={() => handleManualBlur("description")}
                />
                <Error field="description" />
              </div>
            </div>
          </div>
          <div className="row mb-3 mt-2 ">
            <div>
              <Button
                className="btn btn-info w-100 btn-bordered ml-3"
                onClick={handleEditSubscription}
              >
                Edit
              </Button>
            </div>
          </div>
        </div>
        {loading ? <Loader /> : null}
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user,
    channel: state.navigation.channel
  };
};

export default compose(
  withRouter,
  enhancer,
  connect(mapStateToProps, {
    success,
    error,
    fetching
  })
)(EditSubscription);

EditSubscription.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote", "link"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" }
    ]
  ],
  clipboard: {
    matchVisual: false
  }
};
EditSubscription.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link"
];
